import $ from "jquery";
import setAppLinksParams from "scripts/components/setAppLinksParams";
import dragScrolling from "scripts/utils/dragScrolling";
import { GAPageView } from "scripts/components/ga/page_view";
import header from "../components/header";
import sliders from "../components/sliders";
import Select from "../components/select";
import response from "../components/response";
import productPage from "../components/product";
import wishlist from "../components/wishlist/wishlist";
import forms from "../components/forms";
import modals from "../components/modals";
import { initMinicardEvents } from "../components/minicard";
import eSputnik from "../components/eSputnik";
import { isVisibleNode } from "../utils";
import { initSupport } from "scripts/components/support/support";
import { initLazyLoadingRecaptcha } from "scripts/components/recaptcha/recaptcha";
import { installGoogleTranslateShim } from "scripts/utils/googleTranslateShim";

installGoogleTranslateShim();

global.$ = global.jQuery = $;

document.addEventListener("DOMContentLoaded", () => {
  header();
  sliders();
  response();
  productPage();
  forms();
  modals();
  wishlist();
  initMinicardEvents();
  dragScrolling();
  window.customSelect = new Select();
  setAppLinksParams();
  initSupport();
  initLazyLoadingRecaptcha();

  eSputnik.ProductPage({
    'isInStock': Number(isVisibleNode(document.querySelector('.availability .available'))),
    'price': String(window.productDetails?.price || 0),
    'productKey': window.productDetails?.id
  });
  GAPageView();
});